import * as types from './mutation-types'

export default {
  setHotPickupSelectedPostcode ({ commit }, postcode) {
    commit(types.SET_HOT_PICKUP_SELECTED_POSTCODE, postcode)
  },

  setHotPickupSelectedPrefecture ({ commit }, prefecture) {
    commit(types.SET_HOT_PICKUP_SELECTED_PREFECTURE, prefecture)
  },

  setHotPickupSelectedCity ({ commit }, city) {
    commit(types.SET_HOT_PICKUP_SELECTED_CITY, city)
  },

  setHotDeliverySelectedPostcode ({ commit }, postcode) {
    commit(types.SET_HOT_DELIVERY_SELECTED_POSTCODE, postcode)
  },

  setHotDeliverySelectedPrefecture ({ commit }, prefecture) {
    commit(types.SET_HOT_DELIVERY_SELECTED_PREFECTURE, prefecture)
  },

  setHotDeliverySelectedCity ({ commit }, city) {
    commit(types.SET_HOT_DELIVERY_SELECTED_CITY, city)
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/ui/actions.js